const TABS = [
  { key: "OPEN", label: "Активные", statuses: ["CREATED", "IN_PROGRESS"] },
  { key: "COMPLETED", label: "Завершённые", statuses: ["COMPLETED"] },
  { key: "DISPUTE", label: "Спор", statuses: ["DISPUTE"] },
  { key: "CANCELLED", label: "Отменены", statuses: ["CANCELLED"] },
];

export default function ExchangeTabs({ tab, onTabChange }) {
  return (
    <div
      className="
        mt-4 bg-[#F2F5FB] rounded-[16px] p-2
        flex flex-col gap-2
        sm:grid sm:grid-cols-2 sm:gap-2 sm:auto-rows-fr
        lg:flex lg:flex-row lg:flex-nowrap
      "
    >
      {TABS.map((t) => (
        <button
          key={t.key}
          type="button"
          onClick={() => onTabChange(t.key)}
          className={`h-[44px] w-full rounded-[14px] font-semibold ${
            tab === t.key
              ? "bg-white border border-[var(--blue-3)] text-[var(--blue-3)]"
              : "text-[#6B7280]"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}